module.exports = __webpack_public_path__ + "img/footer-image@2x.9c0ebf1e.png";